import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-022af842"),n=n(),_popScopeId(),n)
const _hoisted_1 = { for: "frm-estateAddForm_address" }
const _hoisted_2 = { class: "form-field full-width" }
const _hoisted_3 = { for: "frm-estateAddForm_map" }
const _hoisted_4 = {
  id: "frm-estateAddForm_map",
  class: "google-map",
  ref: "googleMap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoogleAutocomplete = _resolveComponent("GoogleAutocomplete")!
  const _component_MapControls = _resolveComponent("MapControls")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-field full-width", { 'is-danger': _ctx.hasError }])
    }, [
      _createElementVNode("label", _hoisted_1, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.label), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.$t('MapPosition.label')) + ":", 1)
            ], 64))
      ]),
      _createVNode(_component_GoogleAutocomplete, {
        id: "frm-estateAddForm_address",
        name: "address",
        placeholder: _ctx.$t('MapPosition.placeholder'),
        class: "form-control is-required",
        style: {"width":"100%"},
        country: _ctx.country,
        onPlacechanged: _ctx.onPlaceChanged,
        modelValue: _ctx.autocompleteText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.autocompleteText) = $event))
      }, null, 8, ["placeholder", "country", "onPlacechanged", "modelValue"]),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('MapPosition.label-map')) + ":", 1),
      _createElementVNode("div", _hoisted_4, null, 512),
      (_ctx.map)
        ? (_openBlock(), _createBlock(_component_MapControls, {
            key: 0,
            map: _ctx.map
          }, null, 8, ["map"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}